import SiteNavbar from '../../components/feature/SiteNavbar';
import FooterSection from '../home/components/FooterSection';
import KPHero from './components/KPHero';
import KPDashboardMock from './components/KPDashboardMock';
import KPFeatures from './components/KPFeatures';

export default function KlientskyPortalPage() {
  return (
    <div className="bg-zinc-950 min-h-screen">
      <title>Klientský portál - sledujte stav projektu online | Boostio</title>
      <meta
        name="description"
        content="Každý klient Boostio dostáva prístup do vlastného online portálu. Stav projektu, úlohy, aktívne služby, faktúry a mesačné reporty - všetko na jednom mieste."
      />
      <SiteNavbar />
      <main>
        <KPHero />
        <KPDashboardMock />
        <KPFeatures />
      </main>
      <FooterSection />
    </div>
  );
}
